import { useAuth0 } from '@auth0/auth0-react';
import { webStorageService } from '@pn/services/storage/webStorageService';

export function useLogout(): (params?: { returnTo?: string }) => void {
  const { logout } = useAuth0();

  return (params) => {
    clearInvitationData();

    logout({
      logoutParams: {
        returnTo: params?.returnTo ?? window.location.origin,
      },
    });
  };
}

export function clearInvitationData() {
  webStorageService('pn').unset('invite-string');
  webStorageService('pn').unset('invite-email');
  webStorageService('pn').unset('invite-enterprise-name');
}
